import { render, staticRenderFns } from "./ActionPlanRisk.vue?vue&type=template&id=2e1a785e"
import script from "./ActionPlanRisk.vue?vue&type=script&lang=js"
export * from "./ActionPlanRisk.vue?vue&type=script&lang=js"
import style0 from "./ActionPlanRisk.vue?vue&type=style&index=0&id=2e1a785e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports